import { nanoid } from 'nanoid';
import useLocalStorage from 'use-local-storage-state';

export const useDeviceId = () => {
  const [deviceId] = useLocalStorage('deviceId', { defaultValue: nanoid() });

  return deviceId!;
};
